var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"af2c27c6d680b3e5fb447933a2062cc8ee074de8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["revibe-marketplace@revibe"]={id:"af2c27c6d680b3e5fb447933a2062cc8ee074de8"};
      